(() => {
  const storageKey = 'myunigoods_wishlist_v1';
  const readSaved = () => {
    try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); }
    catch { return []; }
  };
  let saved = readSaved();
  const dialog = document.querySelector('[data-wishlist-dialog]');
  const list = document.querySelector('[data-wishlist-items]');
  const count = document.querySelector('[data-wishlist-count]');
  let lastWishlistFocus = null;
  let toastTimer;

  function announce(message) {
    const toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2400);
  }

  function safeUrl(value) {
    try {
      const url = new URL(value, window.location.href);
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : '#';
    } catch { return '#'; }
  }

  function persist() {
    try { localStorage.setItem(storageKey, JSON.stringify(saved)); }
    catch { /* The current page still works if browser storage is unavailable. */ }
    updateWishlist();
  }

  function updateWishlist() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = saved.some((item) => String(item.id) === String(button.dataset.wishlistToggle));
      button.classList.toggle('is-saved', active);
      button.setAttribute('aria-pressed', String(active));
      if (button.classList.contains('detail-wishlist')) button.textContent = active ? '♥ Saved to wishlist' : '♡ Save to wishlist';
    });
    if (count) {
      count.textContent = String(saved.length);
      count.hidden = saved.length === 0;
    }
    renderWishlist();
  }

  function renderWishlist() {
    if (!list) return;
    if (!saved.length) {
      list.innerHTML = '<p class="wishlist-empty">Your saved items will show up here.</p>';
      return;
    }
    list.innerHTML = saved.map((item) => {
      const title = String(item.title || 'Saved item').replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
      const url = safeUrl(item.url);
      return `<div class="wishlist-entry"><a href="${url}">${title}</a><button type="button" data-wishlist-remove="${String(item.id).replace(/[^\w-]/g, '')}">Remove</button></div>`;
    }).join('');
    list.querySelectorAll('[data-wishlist-remove]').forEach((button) => button.addEventListener('click', () => {
      saved = saved.filter((item) => String(item.id) !== button.dataset.wishlistRemove);
      persist();
    }));
  }

  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => button.addEventListener('click', () => {
    const id = button.dataset.wishlistToggle;
    const existing = saved.some((item) => String(item.id) === String(id));
    saved = existing ? saved.filter((item) => String(item.id) !== String(id)) : [...saved, { id, title: button.dataset.wishlistTitle || 'Saved item', url: button.dataset.wishlistUrl || '#' }];
    persist();
    announce(existing ? 'Removed from your saved items' : 'Saved for later');
  }));

  function openWishlist() {
    if (!dialog) return;
    lastWishlistFocus = document.activeElement;
    renderWishlist();
    dialog.classList.add('is-open');
    dialog.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    dialog.querySelector('[data-wishlist-close]')?.focus();
  }
  function closeWishlist() {
    if (!dialog) return;
    dialog.classList.remove('is-open');
    dialog.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lastWishlistFocus?.focus();
  }
  document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.addEventListener('click', openWishlist));
  document.querySelectorAll('[data-wishlist-close]').forEach((button) => button.addEventListener('click', closeWishlist));
  if (dialog) dialog.addEventListener('click', (event) => { if (event.target === dialog) closeWishlist(); });
  document.addEventListener('keydown', (event) => {
    if (!dialog?.classList.contains('is-open')) return;
    if (event.key === 'Escape') closeWishlist();
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  const progress = document.querySelector('[data-scroll-progress]');
  const header = document.querySelector('.site-header');
  let scrollFrame = 0;
  function updateScrollState() {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (progress) progress.style.setProperty('--scroll-progress', `${scrollable > 0 ? Math.min(100, Math.max(0, window.scrollY / scrollable * 100)) : 0}%`);
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', () => {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(() => { updateScrollState(); scrollFrame = 0; });
  }, { passive: true });
  window.addEventListener('resize', updateScrollState, { passive: true });
  updateScrollState();

  document.querySelectorAll('[data-password-toggle]').forEach((button) => button.addEventListener('click', () => {
    const input = document.getElementById(button.dataset.passwordToggle);
    if (!input) return;
    const showing = input.type === 'text';
    input.type = showing ? 'password' : 'text';
    button.textContent = showing ? 'Show' : 'Hide';
    button.setAttribute('aria-label', `${showing ? 'Show' : 'Hide'} password`);
  }));

  document.querySelectorAll('[data-address-delete]').forEach((button) => button.addEventListener('click', () => {
    if (window.Shopify && window.Shopify.CustomerAddress) window.Shopify.CustomerAddress.destroy(button.dataset.addressDelete);
  }));

  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!motionPreference.matches && 'IntersectionObserver' in window) {
    const animated = document.querySelectorAll('.hero-copy,.hero-art,.section-space,.section-heading,.value-strip,.product-card,.category-card,.value-item,.contact-card,.contact-method,.auth-card,.newsletter,.collection-heading,.collection-toolbar,.product-detail-info,.order-summary');
    animated.forEach((element, index) => {
      element.classList.add('motion-in');
      if (element.matches('.product-card,.category-card,.value-item')) element.style.setProperty('--motion-delay', `${(index % 4) * 55}ms`);
    });
    document.documentElement.classList.add('motion-ready');
    const observer = new IntersectionObserver((entries, currentObserver) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      }
    }), { threshold: 0.12, rootMargin: '0px 0px -25px 0px' });
    animated.forEach((element) => observer.observe(element));
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    if (select.tagName !== 'SELECT') return;
    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      const price = Number(option.dataset.price || 0);
      const compare = Number(option.dataset.compare || 0);
      const available = option.dataset.available === 'true';
      const money = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 });
      const priceNode = document.querySelector('[data-current-price]');
      const compareNode = document.querySelector('[data-compare-price]');
      const addButton = document.querySelector('[data-add-button]');
      const stockNote = document.querySelector('[data-stock-note]');
      if (priceNode) priceNode.textContent = money.format(price / 100);
      if (compareNode) {
        compareNode.hidden = compare <= price;
        compareNode.textContent = compare > price ? money.format(compare / 100) : '';
      }
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? `Add to bag · ${money.format(price / 100)}` : 'Sold out';
      }
      if (stockNote) stockNote.textContent = available ? 'Available to add to your bag' : 'This option is sold out';
    };
    select.addEventListener('change', updateVariant);
  });

  updateWishlist();
})();
